import PropertyTreeNode from '../Node/PropertyTreeNode'
import FloatField from '../../Inputs/FloatField'

const PropertyTreeFloatNode = (props) => {
  return <PropertyTreeNode {...props} input={<FloatField {...props} />} />
}
export default PropertyTreeFloatNode
